import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => {
	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: '100%',
				backgroundColor: '#F8F8F8AD',
			}}>
			<div
				style={{ left: '50%', top: '50%', zIndex: 1000, position: 'absolute' }}>
				<CircularProgress color='primary' />
			</div>
		</div>
	);
};

export default Loader;
